// eslint-disable-next-line import/prefer-default-export
export const updatePath = (url = window.location.pathname) => {
	return async dispatch => {
		dispatch({
			type: "SET_ROUTE",
			path: url
		});
	};
};
